import { Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PageRoutes from '../Config/PageRoutes';
import { Link } from 'react-router-dom';
import React from 'react';

import classes from '../Style/Layout.scss';



const ImportantConceptsLinkMobile = (props) => {
return (       
      
	        <Box  sx={{position:'absolute', right:'0',   }} className='ImportantBtnMobile'>
                <Link to={PageRoutes.IMPORTANT_CONCEPTS}>
	                <Box display='flex' flexDirection='row' alignItems='center' className="importanBtnMobile" justifyContent='center'>                              
                           <InfoOutlinedIcon style={{ color: 'white' }}/> 
                                                          
                         </Box>
                 </Link>
	        </Box>
	


);

}

export default ImportantConceptsLinkMobile;